import { render, staticRenderFns } from "./DentSubtableList.vue?vue&type=template&id=4bfa556a&scoped=true&"
import script from "./DentSubtableList.vue?vue&type=script&lang=js&"
export * from "./DentSubtableList.vue?vue&type=script&lang=js&"
import style0 from "./DentSubtableList.vue?vue&type=style&index=0&id=4bfa556a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfa556a",
  null
  
)

export default component.exports